import { ExternalLink } from "lucide-react";
import { PAYMENT } from "@/data/content";

const REVOLUT_PREFIX = "https://revolut.me/";

export const hasRevolutLink = () => (PAYMENT.revolutLink || "").toLowerCase().startsWith(REVOLUT_PREFIX);

/**
 * Tap-to-pay deposit button (Revolut.me). Renders nothing until a link is saved in /admin.
 * `amount` is an optional display amount, e.g. "€52.50".
 */
export const RevolutDepositButton = ({ amount, dark = false, testId = "revolut-deposit-button" }) => {
  if (!hasRevolutLink()) return null;
  return (
    <div data-testid={`${testId}-wrap`}>
      <a
        data-testid={testId}
        href={PAYMENT.revolutLink}
        target="_blank"
        rel="noopener noreferrer"
        className={`inline-flex items-center gap-2 rounded-full px-6 py-3 text-sm font-semibold transition-colors ${
          dark ? "bg-white text-[#1B3A6B] hover:bg-[#D4AF37]" : "bg-[#1B3A6B] text-white hover:bg-[#8A6D1F]"
        }`}
      >
        Pay {amount ? `${amount} ` : ""}deposit via Revolut <ExternalLink size={14} />
      </a>
      <p data-testid={`${testId}-note`} className={`mt-2 text-[11px] leading-relaxed ${dark ? "text-white/60" : "text-[#67718A]"}`}>
        {PAYMENT.depositNote} Card, Apple Pay and Google Pay are accepted through Revolut — please use your name as the reference.
      </p>
    </div>
  );
};
